import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import arrowRightUpIcon from "../../assets/track-icon/info-icons/arrow-up-right-white.svg";
import blueCircularTick from "../../assets/track-icon/info-icons/blue-circular-tick.svg";
import { planTypes } from "../../utils/Constants";
import { useLocation } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        width: '100%',
    },
    cardsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    card: {
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        },
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        padding: '1rem',
        margin: '1rem auto 2rem auto',
        width: '24rem',
        textAlign: 'start',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    cardHeader: {
        height: '7rem',
        overflow: 'auto',
        '& h3': {
            margin: '0'
        },
    },
    cardContent1: {
        '& button': {
            [theme.breakpoints.down("sm")]: {
                width: '100%',
            },
            textTransform: 'none',
            background: '#315CD5 !important',
            padding: '1rem',
            borderRadius: '8px',
            color: '#FFF',
            height: '2.5rem',
            width: '100%',
            '& img': {
                width: '0.8rem',
                marginBottom: '-1px',
            }
        },
    },
    cardContent2: {
        overflow: 'auto',
        height: '15rem',
    },
    bulletPoints: {
        display: 'flex',
        gap: '0.5rem',
        margin: '10px 0',
        alignItems: 'start',
    },
}))

const GetHired = ({ productInfo, currTrackDetails, ...props }) => {

    const classes = useStyles();
    const { search } = useLocation();

    const enrollFreePlan = (email) => {
        const t = currTrackDetails && currTrackDetails.productInfo && !!currTrackDetails.productInfo.length && currTrackDetails.productInfo.find(t => t.subProductType === planTypes.TRACKPLANFREE);
        let redirecturl;
        if (t) {
            redirecturl = process.env.REACT_APP_EVAL_URL + `${search ? (search + '&') : '?'}lptrackid=${currTrackDetails.trackId}&lpproductid=${t.productId}&lpflowtype=enroll`
            if (email) {
                redirecturl = redirecturl + `&lpemail=${email}`
            }
            window.location.href = redirecturl;
        } else {
            alert("No free plan available for this track!")
        }
    }

    const onClickOfPlan = (planInfo) => {
        if (planInfo.subProductType === planTypes.TRACKPLANSUBSCRIPTION) {
            window.location.href = process.env.REACT_APP_EVAL_URL + `${search ? (search + '&') : '?'}lptrackid=${currTrackDetails.trackId}&lpproductid=${planInfo.productId}&lpflowtype=buy`
            return;
        }
        if (planInfo.subProductType === planTypes.TRACKPLANCONTRACT) {
            props.showContactForm();
            return;
        }
        if (planInfo.subProductType === planTypes.TRACKPLANEVALUATION) {
            window.location.href = process.env.REACT_APP_EVAL_URL + `${search ? (search + '&') : '?'}lptrackid=${currTrackDetails.trackId}&lpproductid=${planInfo.productId}&lpflowtype=evalbuy`
            return;
        }
        if (planInfo.subProductType === planTypes.TRACKPLANPLACEMENT) {
            let placementPartner = "";
            if (currTrackDetails.placementPartner) {
                placementPartner = `&company=${currTrackDetails.placementPartner.name}`;
            }
            window.location.href = process.env.REACT_APP_EVAL_URL + `${search ? (search + '&') : '?'}lptrackid=${currTrackDetails.trackId}&lpproductid=${planInfo.productId}&lpflowtype=placement${placementPartner}`
            return;
        }
        if (planInfo.subProductType === planTypes.TRACKPLANFREE) {
            enrollFreePlan(undefined);
            return;
        }
    }

    const getButtonName = (subProductType, price) => {
        if (subProductType === planTypes.TRACKPLANFREE) {
            return `Start for free`;
        }
        if (subProductType === planTypes.TRACKPLANCONTRACT) {
            return "Let's Connect";
        }
        return `(${price}$) Start Course`
    }

    return (
        <section className={classes.root} ref={props.productsRef}>
            <h1>Get Hired by FAANG Choose Your Program Today</h1>
            <p>Choose from our programs that offer personalized coaching and self-preparation. Our experienced FAANG Technical Program Managers will guide you every step of the way. From resume review to mock interviews. </p>
            <div className={classes.cardsContainer}>
                {
                    productInfo.map((plan, idx) => (
                        <div className={classes.card} key={plan.displayName + idx}>
                            <div className={`${classes.cardHeader} ${props.helperClasses.customScroll}`}>
                                <h3>{plan.displayName} </h3>
                                <p>{plan.description}</p>
                            </div>
                            <div className={classes.cardContent1}>
                                <Button onClick={() => onClickOfPlan(plan)}>
                                    <span>{getButtonName(plan.subProductType, plan.price)}&nbsp;&nbsp;</span>
                                    <img src={arrowRightUpIcon} />
                                </Button>
                            </div>
                            <div className={`${classes.cardContent2} ${props.helperClasses.customScroll}`}>
                                <p><b>This plan includes</b></p>
                                {
                                    plan.displayDescription.map((keyPoint, idx) => (
                                        <div className={classes.bulletPoints} key={keyPoint + idx}>
                                            <img src={blueCircularTick} />
                                            <span>{keyPoint}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </section>
    )
}

export default GetHired;